<template>
  <div>
    <b-modal
      size="xl"
      header="Catalog tree"
      border-variant="info"
      header-bg-variant="primary"
      header-text-variant="white"
      v-model="isshow"
      no-close-on-backdrop
      id="ordermodal"
      v-if="isshow && currentOrderData"
    >
      <div slot="modal-header">
        New Order #
        <b>{{ currentOrderData.fullfillmentId}}</b>
      </div>
      <div>
        <div class="row">
          <div class="col-lg-5">
            <div class="card">
              <div class="card-body">
                <h5 class="header-title">Order Details</h5>
                <ul class="list-unstyled">
                  <li>
                    <span class="font-weight-bold mb-3">Amount :</span>
                    {{ currentOrderData.orderAmount }}
                  </li>
                  <li style="margin-top:5px">
                    <span class="font-weight-bold mb-3">Payment Type :</span>
                    {{ currentOrderData.paymentType }}
                  </li>
                  <li style="margin-top:5px">
                    <span class="font-weight-bold mb-3">Delivery Charge :</span>
                    {{ currentOrderData.deliveryCharges }}
                    {{ currentOrderData.orderCurrency }}
                  </li>
                </ul>
                 <div
                v-if=" currentOrderData.deliveryAddress && currentOrderData.deliveryAddress.address"
              >
                <h5 class="header-title mt-3">Delivery Address</h5>
                <address
                  class="mb-0 font-15 address-lg"
                  v-if="currentOrderData.deliveryAddress.address"
                >
                  {{ currentOrderData.deliveryAddress.address.houseNumber }} ,
                  {{ currentOrderData.deliveryAddress.address.street1 }},
                  {{ currentOrderData.deliveryAddress.address.street2 }}
                  <br />
                  <span class="mb-2">City :</span>
                  {{ currentOrderData.deliveryAddress.address.city }} -
                  {{ currentOrderData.deliveryAddress.address.state }} ({{
                    currentOrderData.deliveryAddress.address.country
                  }})
                  <br />
                  <span class="mb-2">Pincode :</span>
                  {{ currentOrderData.deliveryAddress.address.zip }}
                  <br />
                </address>
              </div>
              <b-row class="mt-3">
          <b-col>
            <div>
              <h5>ETA <i style="color:black" class="ti-calendar"></i> :</h5>
              <div>
                <input class="form-control" 
                style="width:46%;background-color :#ffeea9;" 
                type="datetime-local"  
                id="example-datetime-local-input">
                <!-- <datetime
                  style="background-color :#ffeea9; border:1px solid black"
                  type="datetime"
                  input-class="etaInput"
                  v-model="ETATime"
                  :format="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: '2-digit'
                  }"
                  :phrases="{ ok: 'Continue', cancel: 'Exit' }"
                  :hour-step="2"
                  :minute-step="15"
                  :week-start="7"
                  use12-hour
                  auto
                  class="theme-nipige"
                > </datetime> -->
              </div>
            </div>
          </b-col>
          <b-col >
            <div>
              <h5>Pick up time :</h5>
              <div>
                 <input class="form-control" 
                 style="width:46%;background-color :#ffeea9;" 
                 type="datetime-local"  
                 id="example-datetime-local-input">
                <!-- <datetime
                  style="background-color :#ffeea9;"
                  type="datetime"
                  input-class="etaInput"
                  v-model="pickUpTime"
                  :format="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: '2-digit'
                  }"
                  :phrases="{ ok: 'Continue', cancel: 'Exit' }"
                  :hour-step="2"
                  :minute-step="15"
                  :week-start="7"
                  use12-hour
                  auto
                  class="theme-nipige"
                ></datetime> -->
              </div>
            </div>
          </b-col>
        </b-row>
              </div>
            </div>
          </div>
          <div class="col-lg-7">
            <div class="card">
              <!-- <div
                class="card-body"
                v-if="currentOrderData.deliveryAddress.address"
              >
                <h5 class="header-title">Delivery Address</h5>
                <address
                  class="mb-0 font-15 address-lg"
                  v-if="currentOrderData.deliveryAddress.address"
                >
                  {{ currentOrderData.deliveryAddress.address.houseNumber }} ,
                  {{ currentOrderData.deliveryAddress.address.street1 }},
                  {{ currentOrderData.deliveryAddress.address.street2 }}
                  <br />
                  <span class="mb-2">City :</span>
                  {{ currentOrderData.deliveryAddress.address.city }} -
                  {{ currentOrderData.deliveryAddress.address.state }} ({{
                    currentOrderData.deliveryAddress.address.country
                  }})
                  <br />
                  <span class="mb-2">Pincode :</span>
                  {{ currentOrderData.deliveryAddress.address.zip }}
                  <br />
                </address>
              </div> -->
              <div>
          <div class="wrap">
            <table class="table table-centered mb-0">
              <thead class="thead-dark">
                <tr>
                  <th>No</th>
                  <th>Item Image</th>
                  <th>Name</th>
                  <th>Price</th>
                  <th>Quantity</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, idx) in currentOrderData.items"
                  :key="'arr' + idx"
                >
                  <td>{{ idx + 1 }}</td>
                  <td>
                    <img
                      class="mr-2 rounded"
                      :src="item.imageLink"
                      alt="Generic placeholder image"
                      height="42"
                    />
                  </td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.price }}</td>
                  <td>
                    <i class="mdi mdi-circle text-success"></i>
                    {{ item.qty }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
            </div>
          </div>
        </div>

        <!-- <div class="card-table">
          <b-card class="wrap">
            <table class="table table-centered mb-0">
              <thead class="thead-dark">
                <tr>
                  <th>No</th>
                  <th>Item Image</th>
                  <th>Name</th>
                  <th>Price</th>
                  <th>Quantity</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, idx) in currentOrderData.items"
                  :key="'arr' + idx"
                >
                  <td>{{ idx + 1 }}</td>
                  <td>
                    <img
                      class="mr-2 rounded"
                      :src="item.imageLink"
                      alt="Generic placeholder image"
                      height="42"
                    />
                  </td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.price }}</td>
                  <td>
                    <i class="mdi mdi-circle text-success"></i>
                    {{ item.qty }}
                  </td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </div> -->

        <!-- <b-row>
          <b-col md="5">
            <div>
              <h5>ETA :</h5>
              <div>
                <datetime
                  style="background-color :red; color:white;"
                  type="datetime"
                  input-class="etaInput"
                  v-model="ETATime"
                  :format="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: '2-digit'
                  }"
                  :phrases="{ ok: 'Continue', cancel: 'Exit' }"
                  :hour-step="2"
                  :minute-step="15"
                  :week-start="7"
                  use12-hour
                  auto
                  class="theme-nipige"
                ></datetime>
              </div>
            </div>
          </b-col>
          <b-col md="5">
            <div>
              <h5>Pick Up time :</h5>
              <div>
                <datetime
                  style="background-color :mintcream;"
                  type="datetime"
                  input-class="etaInput"
                  v-model="pickUpTime"
                  :format="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: '2-digit'
                  }"
                  :phrases="{ ok: 'Continue', cancel: 'Exit' }"
                  :hour-step="2"
                  :minute-step="15"
                  :week-start="7"
                  use12-hour
                  auto
                  class="theme-nipige"
                ></datetime>
              </div>
            </div>
          </b-col>
        </b-row> -->
      </div>
      <div slot="modal-footer" v-if="newOrderNotification.message.type === 'order-request'" >
        <b-button variant="primary" @click="acceptOrder">Accept</b-button>
        <b-button class="ml-2" variant="danger" @click="rejectOrder"
          >Reject</b-button
        >
        <b-button class="ml-2" variant="warning" @click="isshow = false"
          >Ignore</b-button
        >
      </div>
      <div slot="modal-footer" v-if="newOrderNotification.message.type === 'manufacturer-order-request'" >
        <b-button class="ml-2" variant="warning" @click="isshow = false"
          >Close</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import Axios from "axios";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
export default {
  name: "OrderModal",
  components: {
    datetime: Datetime
  },
  data() {
    return {
      ETATime: "",
      pickUpTime: "",
      isshow: true
    };
  },
  computed: {
    currentOrderData() {
      return this.$store.getters["notification/GetCurrentOrderDetails"];
    },
    newOrderNotification() {
      return this.$store.getters["notification/GetNewOrderNotification"];
    }
  },
  methods: {
    async acceptOrder() {
      console.log(this.newOrderNotification);
      let taskdata = await Axios.get(
        this.newOrderNotification.message.taskDataLink
      );

      let payload = {
        url: this.newOrderNotification.message.taskUpdateLink,
        data: {
          workflowInstanceId: taskdata.data.taskStatus.workflowInstanceId,
          taskId: taskdata.data.taskStatus.taskId,
          status: "COMPLETED",
          outputData: {
            approval: true,
            eta: this.ETATime,
            pickUpTime: this.pickUpTime
          }
        }
      };
      console.log("message", this.currentOrderMessage);
      console.log("Acceptorder", payload);
      this.$store.dispatch("order/acceptCurrentOrder", payload).then(res => {
        this.isshow = false;
        let messageObj = {
          id: this.newOrderNotification._id
        };
        let userdata = JSON.parse(sessionStorage.getItem("userLogin"));
        let object = {
          uid: userdata._id
        };
        console.log(messageObj);

        this.$socket.emit("read", messageObj);
        this.$socket.emit("getunread", object);
        this.ETATime = "";
        this.pickUpTime = "";
        this.$swal({
          title: "Accepted!",
          text: "New Order Accepted Successfully!",
          type: "success"
        });
      });
    },
    async rejectOrder() {
      console.log(this.newOrderNotification);
      let taskdata = await Axios.get(
        this.newOrderNotification.message.taskDataLink
      );

      let payload = {
        url: this.newOrderNotification.message.taskUpdateLink,
        data: {
          workflowInstanceId: taskdata.data.taskStatus.workflowInstanceId,
          taskId: taskdata.data.taskStatus.taskId,
          status: "COMPLETED",
          outputData: {
            approval: false,
            eta: this.ETATime,
            pickUpTime: this.pickUpTime
          }
        }
      };
      console.log("message", this.currentOrderMessage);
      console.log("Acceptorder", payload);
      this.$store.dispatch("order/acceptCurrentOrder", payload).then(res => {
        this.isshow = false;
        let messageObj = {
          id: this.newOrderNotification._id
        };
        let userdata = JSON.parse(sessionStorage.getItem("userLogin"));
        let object = {
          uid: userdata._id
        };
        console.log(messageObj);

        this.$socket.emit("read", messageObj);
        this.$socket.emit("getunread", object);
        this.$swal({
          title: "Rejected!",
          text: "Order is Rejected!",
          type: "success"
        });
      });
    }
  }
};
</script>
<style scoped>
.card-body {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.5rem;
}
.card {
  border: none;
  -webkit-box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);
  margin-bottom: 24px;
}
.card {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid #eef2f7;
  border-radius: 0.25rem;
}
body {
  margin: 0;
  font-family: 'Lato';
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: #6c757d;
  text-align: left;
  background-color: #fafbfe;
}
.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}
.list-unstyled {
  padding-left: 0;
  list-style: none;
}
dl,
ol,
ul {
  margin-top: 0;
  margin-bottom: 1rem;
}
ul {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}
p {
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
li {
  text-align: -webkit-match-parent;
}
.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.card .header-title {
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.02em;
 font-size: 1.1rem;
  margin-top: 0;
}
.mb-3,
.my-3 {
  margin-bottom: 1.5rem !important;
}
.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 10px 0;
  font-weight: 700;
}
address.address-lg {
  line-height: 24px;
}
.font-14 {
  font-size: 14px !important;
}
.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}
address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}
.mb-2 {
  font-weight: 700 !important;
  font-family: 'Lato';
  color: #6c757d;
}
address {
  display: block;
  font-style: ROBOTO;
  font-size: 20px;
}
.col-lg-4 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.33333%;
  flex: 0 0 33.33333%;
  max-width: 33.33333%;
}
.card {
  border: none;
  -webkit-box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);
  margin-bottom: 24px;
}
table th {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  width: 500px;
}

/* == Just general styling, not relevant :) == */

table {
  border-collapse: collapse;
  display: inline-block;
  height: 450px;
  overflow: auto;
}
th,
td {
  padding: 1em 0.5em;
}

table tr {
  color: #212121;
}

.theme-nipige .vdatetime-popup__header,
.theme-nipige .vdatetime-calendar__month__day--selected > span > span,
.theme-nipige .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #ff9800;
}

.theme-nipige .vdatetime-year-picker__item--selected,
.theme-nipige .vdatetime-time-picker__item--selected,
.theme-nipige .vdatetime-popup__actions__button {
  color: #ff9800;
}
.etaInput {
  border-color: solid black;
}
</style>
